import { render, staticRenderFns } from "./IconSvgPlay.vue?vue&type=template&id=3199a620&scoped=true&"
import script from "./IconSvgPlay.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3199a620",
  null
  
)

export default component.exports